import React, { memo } from 'react';
import classNames from 'classnames';

import style from './style.module.css';

const ColoredComponent = ({ data, value }) => {
  if (!data) return <span />;

  return <span className={classNames(style.host, { [style.negative]: !value })}>{value ? 'Y' : 'N'}</span>;
};

export const Colored = memo(ColoredComponent);
